function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getSectionInnerHTML (html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

function refreshCartCountersWithCount (count) {
  document.querySelectorAll("[cart-counter]").forEach((el) => {
    el.innerHTML = count;
  });
  document.querySelectorAll("cart-counter").forEach((el) => {
    el.refreshCount(count);
  });
}

function refreshCartCounters (count) {
  const cartCounterEls = document.querySelectorAll("[cart-counter]");
  const cartCountersComponents = document.querySelectorAll("cart-counter");
  if (cartCounterEls.length > 0 || cartCountersComponents.length > 0) {
    if (count) {
      return refreshCartCountersWithCount(count);
    }
    return fetch(window.routes.cart_url, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.item_count != null) {
          this.refreshCartCountersWithCount(res.item_count);
        }
      });
  }
}

class CartCounter extends HTMLElement {
  constructor() {
    super();
  }

  refreshCount(count) {
    this.innerHTML = count;
  }
}

customElements.define("cart-counter", CartCounter);

class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(
      (button) => button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("cart-drawer-quantity-input", CartDrawerQuantityInput);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById("cart-drawer");
    this.sectionId = this.dataset.sectionId;
    
    this.querySelectorAll("[cart-drawer-close]").forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    // Open buttons (header)
    document.querySelectorAll("[cart-drawer-toggle]").forEach((button) =>
      button.addEventListener("click", this.toggle.bind(this))
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

  }

  toggle() {
    this.drawer.classList.toggle("active");
  }

  open() {
    this.drawer.classList.add("active");
  }

  close() {
    this.drawer.classList.remove("active");
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
  }

  updateQuantity(line, quantity) {

    const body = {
      line,
      quantity,
      sections: [this.sectionId],
      sections_url: window.location.pathname
    };

    fetch(`${window.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.sections && res.sections[this.sectionId]) {
          this.refreshSections(res.sections[this.sectionId]);
        }
        if (refreshCartCounters) {
          refreshCartCounters();
        }
      }).catch((err) => {
        console.error(err);
      });
  }

  refresh(openAfterRefresh) {
    fetch("/?sections=cart-drawer", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then((res) => res.json())
      .then((res) => {
        if (res["cart-drawer"]) {
          this.refreshSections(res["cart-drawer"]);
        }
        if (openAfterRefresh) {
          this.open();
        }
      });

  }

  refreshSections (freshSection) {
    const cartDrawerLineItemsEl = document.getElementById("cart-drawer-line-items");
    const cartDrawerFooterEl = document.getElementById("cart-drawer-footer");
    cartDrawerLineItemsEl.innerHTML = getSectionInnerHTML(freshSection, "#cart-drawer-line-items");
    cartDrawerFooterEl.innerHTML = getSectionInnerHTML(freshSection, "#cart-drawer-footer");
    // Add listeners to the new footer elements
    this.querySelectorAll("[cart-drawer-close]").forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

}

customElements.define("cart-drawer", CartDrawer);
